import { useState } from 'react'
import { Button } from 'components'
import { ThemeDuplicateModal } from './ThemeDuplicateModal'

type ShowState = [boolean, (value: boolean) => void]

export const ThemeDuplicateButton = () => {
  const [show, setShow] = useState(false)

  const buttonText = '🎨 Theme copy'

  return (
    <>
      <Button primary onClick={() => setShow(true)}>
        {buttonText}
      </Button>
      <ThemeDuplicateModal show={[show, setShow] as ShowState} />
    </>
  )
}

export default ThemeDuplicateButton
